<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :xs="{span: 20}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('form_label_status') || '有效状态'" prop="tagStatus">
            <el-radio-group
              style="width: 100%;"
              size="medium"
              disabled
              v-model="formData.tagStatus"
            >
              <el-radio label="Y">{{$l('form_radio_valid')||'有效'}}</el-radio>
              <el-radio label="N">{{$l('form_radio_invalid')||'无效'}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :xs="{span: 20}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('form_label_tag_type') || '标签类型'" prop="tagType">
            <el-radio-group
              style="width: 100%;"
              size="medium"
              :disabled="disabled"
              v-model="formData.tagType"
            >
              <el-radio label="C">{{$l('form_radio_tag_common')||'公共标签'}}</el-radio>
              <el-radio label="P">{{$l('form_radio_tag_private')||'私有标签'}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :xs="{span: 20}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('form_label_tag_name') || '标签名称'" prop="tagName">
            <el-input
              v-model="formData.tagName"
              maxlength="50"
              :disabled="disabled"
              clearable
              size="medium"
              :placeholder="$l('form_label_tag_name') || '标签名称'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="{span: 20}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('form_label_tag_owner') || '标签所属人'" prop="tagOwnerName">
            <el-input
              v-model="formData.tagOwnerName"
              maxlength="50"
              disabled
              size="medium"
              :placeholder="$l('form_label_tag_owner') || '标签所属人'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <div style="font-size: 14px; color: #606266;">
            <span>Create：{{formData.createByName}} at {{formData.createDate}}</span>
            <el-divider direction="vertical"></el-divider>
            <span>Modify：{{formData.modifyByName}} at {{formData.modifyDate}}</span>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      disabled: false,
      formData: {
        tagCode: "",
        tagName: "",
        tagType: [],
        tagStatus: "Y",
        createByName: "",
        tagOwnerName: "",
        createDate: "",
        modifyDate: "",
        modifyByName: "",
      },
      rules: {
        tagName: [
          {
            required: true,
            message: this.$l("form_rule_message_tag_name") || "请输入标签名称",
            trigger: "blur",
          },
          {
            max: 50,
            message:
              this.$l("form_rule_input_length_50") || "长度在50个字符以内",
            trigger: "blur",
          },
        ],
        tagType: [
          {
            required: true,
            message: this.$l("form_rule_message_tag_type") || "请选择标签类型",
            trigger: "change",
          },
        ],
        tagStatus: [
          {
            required: true,
            message: this.$l("form_rule_message_status") || "请选择有效状态",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    // 加载表单数据（新增，编辑，详情）
    fromLoad(ref, val = "") {
      this.init();
      if (ref !== "add") {
        let param = { tagCode: val };
        this.$api.detailDesignElementsTagApi(param).then((res) => {
          this.formData = res.body;
        });
        // 控制组件不可编辑
        if (ref === "detail") {
          this.disabled = true;
        }
      }
    },
    // 保存数据
    save() {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.saveDesignElementsTagApi(this.formData).then(() => {
            this.$message({
              showClose: true,
              message: this.$l("INDEX.tips_save_ok") || "保存成功",
              type: "success",
            });
            // 通知父组件保存成功
            this.$emit("success");
          });
        } else {
          return false;
        }
      });
    },
    // 初始化表单数据
    init() {
      this.disabled = false;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
        this.resetData();
      }
    },
    // 重置表单数据
    resetData() {
      this.formData = {
        tagCode: "",
        tagName: "",
        tagType: [],
        tagStatus: "Y",
        createByName: "",
        tagOwnerName: "",
        createDate: "",
        modifyDate: "",
        modifyByName: "",
      };
    },
  },
};
</script>
